module.exports = __webpack_public_path__ + "static/media/Fire.323bcd9c.webp";